module.exports = __webpack_public_path__ + "img/67_8.2143df09.png";